import { render, staticRenderFns } from "./LayoutWorkspace.vue?vue&type=template&id=ea64b1b8&scoped=true&"
import script from "./LayoutWorkspace.vue?vue&type=script&lang=js&"
export * from "./LayoutWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./LayoutWorkspace.vue?vue&type=style&index=0&id=ea64b1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea64b1b8",
  null
  
)

export default component.exports